import { useState, useEffect } from 'react'
import { EventSourcePolyfill } from 'event-source-polyfill'
import { useLogin } from '../App/LoginContext'

import clientContainer from '~/lib/client'

export function createClient(taskId, token) {
  const { href: url } = clientContainer.client.tasks.eventsUrl(taskId)

  return new EventSourcePolyfill(url, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
}

interface IUseDebugOptions {
  taskId: string
}

const useDebug = (options: IUseDebugOptions) => {
  const { taskId } = options
  const { token } = useLogin()
  const [connected, setConnected] = useState(true)
  const [client, setClient] = useState(null)

  const toggleConnect = () => setConnected(prevIsPlaying => !prevIsPlaying)
  const connect = () => setConnected(true)
  const disconnect = () => setConnected(false)

  useEffect(() => {
    if (!connected) return

    const client = createClient(taskId, token)
    setClient(client)

    return () => client.close()
  }, [connected, options.taskId])

  return {
    client,
    connected,
    toggleConnect,
    connect,
    disconnect,
  }
}

export default useDebug
